// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__219wX","vLegacy":"SelectSecondary_vLegacy__1sKFJ","error":"SelectSecondary_error__3gC1l","disabled":"SelectSecondary_disabled__1kgm1"};